import React from "react";
import { apiCall } from "../common/common";
import { displayLog } from "../common/common";

//config
import config from "../config";
import Axios from "axios";

const CurrencyConverterContext = React.createContext();

const rootReducer = (state, action) => {
  switch (action.type) {
    case "GET_CURRENCY_DATA":
      return {
        isLoaded: true,
        currencyData: action.payload.data,
      };
    case "SET_CURRENCY_DATA":
      return {
        isLoaded: true,
        currencyData: action.payload,
      };
    case "REQUEST_CALLED":
      return {
        isLoaded: false,
        currencyData: [],
      };
    default:
      return {
        ...state,
      };
  }
};

const CurrencyConverterProvider = ({ children }) => {
  //  get feedback content
  const [currencyData, setCurrnecyData] = React.useReducer(rootReducer, {
    isLoaded: true,
    currencyData: [],
  });

  return (
    <CurrencyConverterContext.Provider
      value={{
        currencyData,
        setCurrnecyData,
      }}
    >
      {children}
    </CurrencyConverterContext.Provider>
  );
};

const CurrencyState = () => {
  const context = React.useContext(CurrencyConverterContext);
  return context;
};

//API call to set Help content
export const getCurrencyDatas = async (dispatch) => {
  let response = await apiCall(
    "GET",
    "GET_CURRENCY_DATA",
    "/admin/getCurrency",
    {},
    {},
    {},
    dispatch
  );
  dispatch({ type: "REQUEST_CALLED" });
  if (response && response.data) {
    if (response.data.code === 0) {
      displayLog(0, response.data.message);
    } else {
      dispatch({ type: "GET_CURRENCY_DATA", payload: response.data });
    }
  }
};

export const updateCurrencyData = async (dispatch, reqData) => {
  let response = await apiCall(
    "POST",
    "SET_CURRENCY_DATA",
    "/admin/updateCurrency",
    reqData,
    {},
    {},
    dispatch
  );
  dispatch({ type: "REQUEST_CALLED" });
  if (response && response.data) {
    if (response.data.code === 0) {
      displayLog(0, response.data.message);
    } else {
      dispatch({ type: "SET_CURRENCY_DATA", payload: response.data });
    }
  }
};

export { CurrencyConverterProvider, CurrencyConverterContext, CurrencyState };
